import { defineComponent as a, createBlock as l, openBlock as o, unref as p, mergeProps as c, withCtx as m, createElementVNode as e } from "vue";
import { RevIcon as i } from "@ds/components/Icon";
const d = /* @__PURE__ */ a({
  name: "IconArrowLeftInCircle",
  __name: "IconArrowLeftInCircle",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(n) {
    const r = n;
    return (u, t) => (o(), l(p(i), c(r, { "view-box": "0 0 24 24" }), {
      default: m(() => [...t[0] || (t[0] = [
        e("path", { d: "M17.834 6.166A8.25 8.25 0 1 0 6.166 17.834 8.25 8.25 0 0 0 17.834 6.166m1.06-1.06c3.808 3.807 3.808 9.98 0 13.788-3.807 3.808-9.98 3.808-13.788 0-3.808-3.807-3.808-9.98 0-13.788 3.807-3.808 9.98-3.808 13.788 0" }, null, -1),
        e("path", { d: "M7.757 11.25a.75.75 0 0 0 0 1.5h8.486a.75.75 0 0 0 0-1.5H7.757" }, null, -1),
        e("path", { d: "M11.359 8.944a.75.75 0 0 0-1.06-1.06l-3.233 3.232a1.25 1.25 0 0 0 0 1.768l3.232 3.232a.75.75 0 1 0 1.06-1.06L8.304 12l3.056-3.056" }, null, -1),
        e("path", { d: "M10.298 7.884a.75.75 0 0 1 1.06 1.06L9.054 11.25h7.19a.75.75 0 1 1 0 1.5h-7.19l2.306 2.306a.75.75 0 0 1-1.06 1.06l-3.233-3.232a1.25 1.25 0 0 1 0-1.768l3.232-3.232" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  d as default
};
